/**
 * deviceId.js — Genera y persiste un UUID único por navegador/dispositivo.
 *
 * El ID se almacena en localStorage bajo la clave `sl_device_id` y se envía
 * como header `X-Device-ID` en cada petición HTTP (vía interceptor de axios).
 *
 * Propósito: permitir al admin detectar si dos cuentas distintas usan
 * EXACTAMENTE el mismo dispositivo físico (mismo navegador, mismo localStorage),
 * lo que indicaría que probablemente son la misma persona con cuentas múltiples.
 * Es más fiable que la IP sola, que puede ser compartida por usuarios distintos
 * en la misma red WiFi o 4G.
 *
 * Privacidad: el ID solo identifica el navegador, no al usuario.
 * Si el usuario borra su localStorage, se genera uno nuevo.
 */

const STORAGE_KEY = "sl_device_id";

function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback para navegadores sin crypto.randomUUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateUUID();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage bloqueado (modo privado extremo, algunos Safari)
    return "";
  }
}
